import { LOGOUT } from '../../app/authState'
import { VisitMethods } from '../../pages/new-visit/components/visit-information/VisitMethods'
import { VISIT_LOWER_TEXT, apiErrorCodes } from '../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  GET_PAST_VISIT_INFO,
  GET_PAST_VISIT_INFO_ERROR,
  GET_PAST_VISIT_INFO_SUCCESS,
  GET_PAST_VISIT_PRESCRIPTION,
  GET_PAST_VISIT_PRESCRIPTION_ERROR,
  GET_PAST_VISIT_PRESCRIPTION_SUCCESS,
  GET_PROVIDER_INFO_VISIT_INFO,
  GET_PROVIDER_INFO_VISIT_INFO_ERROR,
  GET_PROVIDER_INFO_VISIT_INFO_SUCCESS,
  SET_PAST_VISIT_ERROR,
} from './PastVisitConstants'

const initialState = {
  pastVisitsInfo: {},

  patient: {
    firstName: 'firstName',
    lastName: 'lastName',
    dateOfBirth: '1996-07-10T08:55:00.000+00:00',
    gender: 'male',
    mrn: '00000000000',
  },
  provider: {
    firstName: 'firstName',
    lastName: 'lastName',
  },
  visitDateTime: '2023-07-10T08:50:00.000+00:00',
  method: VisitMethods.VIDEO,
  status: 'completed',
  visitType: 'value',
}

export default (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case GET_PAST_VISIT_INFO:
    case GET_PAST_VISIT_PRESCRIPTION:
    case GET_PROVIDER_INFO_VISIT_INFO:
      return {
        ...state,
        pastVisitsInfo: {
          ...state.pastVisitsInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...(state.pastVisitsInfo?.[action.extraData.visitId] || {}),
            loading: true,
          },
        },
      }
    case GET_PAST_VISIT_INFO_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      action.payload.Notes?.sort((a, b) => (a.IsAddendum ? 1 : -1))
      return {
        ...state,
        pastVisitsInfo: {
          ...state.pastVisitsInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...(state.pastVisitsInfo?.[action.extraData.visitId] || {}),
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            visitInfo: { ...action.payload },
            loading: false,
          },
        },
      }
    case GET_PAST_VISIT_PRESCRIPTION_SUCCESS:
      return {
        ...state,
        pastVisitsInfo: {
          ...state.pastVisitsInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...(state.pastVisitsInfo[action.extraData.visitId] || {}),
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            prescriptions: action.payload,
            loading: false,
          },
        },
      }
    case GET_PROVIDER_INFO_VISIT_INFO_SUCCESS:
      return {
        ...state,
        pastVisitsInfo: {
          ...state.pastVisitsInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...(state.pastVisitsInfo[action.extraData.visitId] || {}),
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            providerData: { ...action.payload },
            loading: false,
          },
        },
      }
    case GET_PAST_VISIT_INFO_ERROR:
    case GET_PROVIDER_INFO_VISIT_INFO_ERROR:
    case GET_PAST_VISIT_PRESCRIPTION_ERROR:
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case apiErrorCodes.VISIT_NOT_FOUND:
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, VISIT_LOWER_TEXT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        pastVisitsInfo: {
          ...state.pastVisitsInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.pastVisitsInfo[action.extraData.visitId],
            loading: false,
            error: message,
          },
        },
        defaultServerErrorMessage,
      }
    case SET_PAST_VISIT_ERROR:
      return {
        ...state,
        pastVisitsInfo: {
          ...state.pastVisitsInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.pastVisitsInfo[action.payload.visitId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            error: action.payload.error,
          },
        },
      }
    case LOGOUT:
      return { ...initialState }
    default:
      return state
  }
}
